import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

// eslint-disable-next-line import/prefer-default-export
export const useDatasetMappedIcon = (mapValue: number | undefined, mapperId: number) => {
  const { data, isLoading } = useGetDatasetMapperData(mapperId);
  if (isLoading || mapValue === undefined) return null;

  const icon = data?.mappers?.find(m => m.key === mapValue)?.icon;
  if (!icon) return null;

  return `pi ${icon}`;
};
